import { createSlice } from '@reduxjs/toolkit';
import { IResource } from '../../../../dto';
import { setResources } from '../actions';
import { MN_RESOURCES, TYPE_LIST } from '../../../../common';

export interface ResourcesState {
  data: IResource[];
  loading: boolean;
  error: string | null;
}

const initialState: ResourcesState = {
  data: [],
  loading: false,
  error: null,
};

export const resourcesSlice = createSlice({
  name: `${MN_RESOURCES}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setResources, (state, { payload }) => {
      state.data = payload;
    });
  },
});
